<script>

    export let text = ''
    export let size = '5'

</script>

<div class="subtitle is-{ size }">{ text }</div>